import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Diving Tours', href: '#tours' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Contact', href: '#contact' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-black/75 backdrop-blur-md'
      }`}
    >
      <div className="w-full px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#home" onClick={(e) => { e.preventDefault(); handleNav('#home'); }} className="flex items-center">
          <img
            alt="Mission Beach Dive Adventures logo"
            className="h-12 w-auto object-contain"
            width={240}
            height={48}
            src="https://storage.readdy-site.link/project_files/c46f7f07-593f-4f17-9a57-3ac86083c18c/8ad1d54c-f962-4091-84fc-ce9d0111f123_1-4.png?v=f770e7fb4e5aaa93207d098e21607861"
          />
        </a>

        <div className={`hidden md:flex items-center gap-8 text-sm font-light ${scrolled ? 'text-gray-600' : 'text-white/80'}`}>
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className={`hover:text-orange-500 transition-colors cursor-pointer whitespace-nowrap ${scrolled ? 'hover:text-orange-500' : 'hover:text-white'}`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <a
          href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
          target="_blank"
          rel="noopener noreferrer"
          className="whitespace-nowrap hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold cursor-pointer transition-all duration-300 hover:scale-105"
        >
          <i className="ri-calendar-check-line"></i>Book Now
        </a>

        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-gray-800' : 'text-white'}`}
          aria-label="Toggle menu"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
              className="text-gray-700 text-sm font-medium py-2 hover:text-orange-500 transition-colors cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-orange-500 text-white text-sm font-semibold mt-2"
          >
            <i className="ri-calendar-check-line"></i>Book Now
          </a>
        </div>
      )}
    </nav>
  );
}
